<div class="row">
    <div class="col-sm-12 text-center">
        <div class="sign-in-forms">
        <div class="text-center">
            <img src="/assets/images/clapping.gif" width="20%">
        </div>
        <ul class="mt-5 non-style">
            <li>
                <h4 class="text-success"> <i class="fa fa-check-circle text-success"></i> Your account creation has
                    succeeded</h4>
            </li>
            <li>
                <h4> <i class="fa fa-circle-o text-secondary"></i> {{userMessage}}</h4>
            </li>
        </ul>


        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="mt-5 mb-5">

            <div class="form-row">
                <div class="col">
                    <input placeHolder="Verification Code" type="text" formControlName="vcode" class="form-control"
                        [ngClass]="{ 'is-invalid': f.vcode.errors && f.vcode.touched }" />
                    <div *ngIf="f.vcode.errors && f.vcode.touched" class="invalid-feedback">
                        <div *ngIf="f.vcode.errors.required">Verification code is required</div>
                    </div>
                </div>
                <div class="col">

                    <button [disabled]="loading" class="btn btn-primary mt-4">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                        Verify Account
                    </button>

                </div>
            </div>




        </form>
</div>
    </div>
</div>
